export default {
    path: ":alias/brands/artist",
    component: resolve => require(["@/views/artist"], resolve),
    children: [
      {
        path: "list",
        component: resolve => require(["@/views/artist/list"], resolve)
      }
    ]
  };
  